import axios from "axios";
import { getPresignedUrlRestApi } from "./getPresignedUrlRestApi";
export const getAllListAssetContracts = {
  mixins: [getPresignedUrlRestApi],
  data() {
    return {
      getAllListAssetContractsArray: [],
      assetContractsAttachmentArray: [],
      overlay: false,
      noDataText: null,
      imageUrls: [],
    };
  },
  methods: {
    async getAllListAssetContractsMethod(qr_code_display_id, asset_qr_code_url) {
      this.overlay = true;
      try {
        this.getAllListAssetContractsArray = [];
        this.assetImagesKeysArray = [];
        const apiUrl = process.env.VUE_APP_AWS_GET_ASSET_CONTRACTS_LIST_REST_API_END_POINT;
        console.log("apiUrl", apiUrl);
        const inputParams = {
          qr_code_display_id: qr_code_display_id,
          asset_qr_code_url: asset_qr_code_url,
        };
        console.log("inputParams", inputParams);
        const result = await axios.post(apiUrl, inputParams, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("result of getAllListAssetContractsMethod", result);
        if (result.data.status === "SUCCESS") {

          this.getAllListAssetContractsArray = result.data.data;

          const AssetContractsAttachment = this.getAllListAssetContractsArray?.[0]?.attachment;
          this.assetContractsAttachmentArray = Array.isArray(AssetContractsAttachment)
            ? AssetContractsAttachment
            : AssetContractsAttachment
              ? [AssetContractsAttachment]
              : [];


          await this.fetchImageUrls();

        }
      } catch (error) {
        console.log("Error in getAllListAssetContractsMethod:", error);

        this.getAllListAssetContractsArray = [];
        this.assetImagesKeysArray = [];
        this.assetContractsAttachmentArray = [];
        this.noDataText = error.message;
        return "ERROR";
      } finally {
        this.overlay = false;
      }
    },
    async fetchImageUrls() {
      const keys = [...this.assetImagesKeysArray];
      if (keys && keys.length > 0) {
        this.imageUrls = await Promise.all(
          keys.map(async (key) => {
            try {
              const url = await this.getPresignedUrlRestApiMethod(key);
              return url;
            } catch (error) {
              console.log("ok..", error);
              return "@/assets/placeHolderImage.jpg"; // Fallback image
            }
          })
        );
      }
    },
  },
};
